module.exports = __webpack_public_path__ + "img/212.b077f102.png";